(() => {
  const loader =
    document.currentScript ||
    document.querySelector("script[data-search-idle-style]");
  const searchHref = loader?.dataset.searchIdleStyle;
  const wishlistHref = loader?.dataset.wishlistStyle;
  const readyPromises = {};

  const loadStyle = (href) => {
    if (!href) return Promise.resolve();
    if (readyPromises[href]) return readyPromises[href];

    const existing = Array.from(
      document.querySelectorAll('link[rel="stylesheet"]'),
    ).find((link) => link.href === href);
    if (existing) return Promise.resolve();

    readyPromises[href] = new Promise((resolve, reject) => {
      const style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = href;
      style.addEventListener("load", resolve, { once: true });
      style.addEventListener("error", reject, { once: true });
      document.head.appendChild(style);
    }).catch((error) => {
      delete readyPromises[href];
      throw error;
    });

    return readyPromises[href];
  };

  const loadSearch = () => loadStyle(searchHref);
  const loadWishlist = () => loadStyle(wishlistHref);

  const isSearchControl = (target) =>
    target.closest(
      ".wt-header__search, .wt-header__search-trigger, search-drawer",
    );

  const isWishlistControl = (target) =>
    target.closest(".wishlist-header-link");

  document.addEventListener(
    "pointerover",
    (event) => {
      if (isSearchControl(event.target)) loadSearch().catch(() => undefined);
      if (isWishlistControl(event.target)) loadWishlist().catch(() => undefined);
    },
    { capture: true, passive: true },
  );
  document.addEventListener(
    "focusin",
    (event) => {
      if (isSearchControl(event.target)) loadSearch().catch(() => undefined);
      if (isWishlistControl(event.target)) loadWishlist().catch(() => undefined);
    },
    true,
  );
  document.addEventListener(
    "pointerdown",
    (event) => {
      if (isSearchControl(event.target)) loadSearch().catch(() => undefined);
      if (isWishlistControl(event.target)) loadWishlist().catch(() => undefined);
    },
    { capture: true, passive: true },
  );

  window.loadSearchIdleStyles = loadSearch;

  if (wishlistHref) {
    const warmWishlist = () => loadWishlist().catch(() => undefined);
    if ("requestIdleCallback" in window) {
      requestIdleCallback(warmWishlist, { timeout: 4000 });
    } else {
      window.setTimeout(warmWishlist, 2500);
    }
  }
})();
